import React, { useState } from 'react';
import '../assets/styles/ParentPortal.css';

const ParentPortal = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) setIsSubmitted(true);
  };

  return (
    <div className="parent-portal-container">
      {/* ───────────────────────── Header ───────────────────────── */}
      <header className="page-header">
        <h1>
          Parent&nbsp;Portal <span className="label-soon">coming&nbsp;soon</span>
        </h1>
        <p>
          One friendly dashboard to follow your child’s AI-powered maths journey, celebrate wins,
          and book extra help when they need it.
        </p>
      </header>

      {/* ────────────── Teaser + email capture box ─────────────── */}
      <section className="coming-soon-section">
        <div className="coming-soon-icon">🚀</div>
        <h2>We’re building something special</h2>
        <p>
          Behind the scenes we’re crunching lesson data, quiz scores and chat history so you’ll
          soon have clear, actionable insights at your fingertips.
        </p>

        {!isSubmitted ? (
          <form className="notify-form" onSubmit={handleSubmit}>
            <div className="form-input-group">
              <input
                type="email"
                placeholder="Enter your email to stay in the loop"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="form-button">Notify Me</button>
          </form>
        ) : (
          <div className="success-message">
            <p>Thanks for subscribing! We’ll ping you the moment the Parent Portal goes live.</p>
            <button className="notify-button" onClick={() => setIsSubmitted(false)}>
              Add another email
            </button>
          </div>
        )}
      </section>

      {/* ───────────────────── Feature previews ─────────────────── */}
      <section className="feature-cards">
        <article className="feature-card">
          <div className="feature-icon">📊</div>
          <h3>Dashboard Snapshot</h3>
          <p>
            Glanceable cards for time-on-task, quiz averages, units completed and last
            activity—refreshed live from DynamoDB.
          </p>
        </article>

        <article className="feature-card">
          <div className="feature-icon">📈</div>
          <h3>Progress & Trends</h3>
          <p>
            Drill-down charts reveal confidence growth, difficulty-mix trends, and “gotcha” areas
            that need revision.
          </p>
        </article>

        <article className="feature-card">
          <div className="feature-icon">🧠</div>
          <h3>SWAT Reports</h3>
          <p>
            Strengths-Weaknesses-Actions-Threats summaries after every mock exam so you know
            exactly where to focus next.
          </p>
        </article>

        <article className="feature-card">
          <div className="feature-icon">📆</div>
          <h3>Session Scheduling</h3>
          <p>
            A built-in calendar to book AI-led revision sessions or live tutor help, synced to
            Google / Outlook.
          </p>
        </article>

        <article className="feature-card">
          <div className="feature-icon">✉️</div>
          <h3>Weekly Updates</h3>
          <p>
            Optional Friday email or push digest with highlights, streaks and gentle nudges when
            focus slips.
          </p>
        </article>
      </section>

      {/* ─────────────── Peek-inside wire-frame ─────────────────── */}
      <section className="sample-dashboard">
        <h2>Peek inside the future</h2>
        <p>
          A rough wire-frame of the dashboard our designers are polishing right now. Expect tidy
          graphs, colour-coded strengths, and tap-to-schedule controls.
        </p>

        <div className="dashboard-preview">
          <span className="preview-label">Wire-frame</span>

          <div className="mock-dashboard">
            {/* ── Row 1 ───────────────────────── */}
            <div className="mock-row">
              <div className="mock-card donut-card">
                <h4>Curriculum Coverage</h4>
                <div className="donut" />
                <p>72 % complete</p>
              </div>

              <div className="mock-card trend-card">
                <h4>Quiz Score Trend</h4>
                <div className="sparkline" />
                <p>Last 8 quizzes • avg 84 %</p>
              </div>
            </div>

            {/* ── Row 2 ───────────────────────── */}
            <div className="mock-row">
              <div className="mock-card swat-card">
                <h4>Latest SWAT</h4>
                <ul className="swat-list">
                  <li><strong>S</strong> Algebraic manipulation</li>
                  <li><strong>W</strong> Quadratic word problems</li>
                  <li><strong>A</strong> Revise factoring steps</li>
                  <li><strong>T</strong> Careless sign errors</li>
                </ul>
              </div>

              <div className="mock-card calendar-card">
                <h4>Upcoming Sessions</h4>
                <div className="calendar-grid">
                  {Array.from({ length: 35 }).map((_, i) => (
                    <div
                      /* just highlight a few arbitrary cells */
                      key={i}
                      className={['calendar-cell',
                        i === 3 || i === 10 || i === 18 || i === 27 ? 'active' : ''
                      ].join(' ')}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ParentPortal;